
import Vue from 'vue';
import { Image } from 'element-ui';

const ElImageConstructor = Vue.extend(Image)

const previewImages = (srcList, index = 0) => {
  srcList = Array.isArray(srcList) ? srcList : srcList ? [srcList] : []

  const initialIndex = typeof index === 'string' ? srcList.indexOf(index) : index
  if (srcList.length < 1) return
  const props = {
    previewSrcList: srcList,
    initialIndex
  }
  const instance = new ElImageConstructor({
    propsData: props,
    watch: {
      showViewer(val) {
        if (!val) {
          instance.$destroy()
          document.body.removeChild(instance.$el)
        }
      }
    }
  })

  instance.$mount()
  document.body.appendChild(instance.$el)
  instance.clickHandler.call(instance)
}

export default previewImages